export const getUserName = (userId, users) => {
  const found = users.find((user) => user.id == userId);
  return found ? found.firstName + " " + found.lastName : null;
};
